<div [ngClass]="{'unit-card':true, 'lpSide': isLpSide }">
    <div class="card-container">
    
    <div class="header">
        <div [ngClass]="{'covercy-logo': true, 'opacity': needOpacity }">
            <img src="/assets/images/logo/covercy-logo-all-white.svg" />
        </div>
        <div class="card-status">
            <div [ngClass]="['circle-status', UnitCardStatus.toString(cardStatus).toLowerCase()]"></div>
            <div class="status">{{cardStatus | enumString:UnitCardStatus}}</div>
        </div>
    </div>
    <div [ngClass]="{'sim-card': true, 'opacity': needOpacity }">
        <img src="/assets/images/unit-card/sim-card.svg" />
    </div>
    <div [ngClass]="{'holder-name': true, 'opacity': needOpacity }">
        {{TerraUtils.getUnitFullName(holderFullName)}}
    </div>
    <div [ngClass]="{'card-number': true, 'opacity': needOpacity }">
        <mat-progress-bar *ngIf="loadingSensitiveData" mode="indeterminate"></mat-progress-bar>
        <div id="{{ 'secured-card-number-' + cardId }}" class="secured-card-number">•••• •••• •••• {{cardNumber}}</div>
        <div id="{{ 'card-number-copy-button-' + cardId }}" class="card-number-copy-button"></div>
    </div>
    <div [ngClass]="{'footer': true, 'opacity': needOpacity }">
        <div class="data">
            <div class="card-exp-date">
                <span class="exp-text">EXP</span>
                <mat-progress-bar *ngIf="loadingSensitiveData" mode="indeterminate"></mat-progress-bar>
                <div class="exp-data-container" *ngIf="!loadingSensitiveData" >
                    <div class="exp-data">{{expDateFormat}}</div>

                    <div class="copy-exp" *ngIf="viewSensitive" [cdkCopyToClipboard]="expDateFormat"
                        (click)="snackbarMessage('Expire Date', $event)">
                    </div>
                </div>
            </div>
            <div class="card-cvv">
                <span class="cvv-number cvv-text">CVV</span>
                <div class="cvv-data">
                    <mat-progress-bar *ngIf="loadingSensitiveData" mode="indeterminate"></mat-progress-bar>
                    <div class="cvv-sensitive">
                        <div id="{{ 'secured-cvv-' + cardId }}" class="secured-cvv">•••</div>
                        <div id="{{ 'cvv-copy-button-' + cardId }}" class="cvv-copy-button"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- &#12539; -->
        <div class="card-company-name">
            <img src="/assets/images/unit-card/card-company.svg" />
        </div>
    </div>
</div>
</div>